import { AfterViewInit, Component, Input } from '@angular/core';
import { ModalComponent } from '../../../../../models/modal-component';
import { Video } from '../../../../../models/video';
import { BookVideoService } from '../../../../../services/book-video.service';
import { LoadingIndicatorComponent } from '../../../../utils/loading-indicator/loading-indicator.component';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { VideoComponent } from '@lemberger/whiteboards';

@Component({
    selector: 'app-video-modal',
    templateUrl: './video-modal.component.html',
    styleUrls: ['./video-modal.component.scss'],
    standalone: true,
    imports: [
        LoadingIndicatorComponent,
        AssetPipe,
        VideoComponent
    ]
})
export class VideoModalComponent extends ModalComponent implements AfterViewInit {
    static MODAL_ID = 'videoModal';
    @Input() declare modalAble: Video;

    urlData: any;
    imageClicked = false;

    constructor(private bookVideoService: BookVideoService) {
        super();
    }

    async ngAfterViewInit() {
        this.urlData = await this.bookVideoService.getURLData(this.modalAble.url);
        $(`#${this.getId()}`).on('hide.bs.modal', () => {
            this.urlData = undefined;
        });
    }

    async showVideo() {
        this.imageClicked = true;
    }

    getId(): string {
        return VideoModalComponent.MODAL_ID;
    }
}
